<div class="astrea-clients">

    <div class="slider_clientes">
        <div class="slide-track-clientes">

            <!-- AJUSTAR LENGTH EN SCSS -->

            <div class="item-clientes">
                <img class="img-responsive" src="/assets/images/clients/capm.png" alt="CAPM" />
            </div>
            <div class="item-clientes">
                <img class="img-responsive" src="/assets/images/clients/ceba.png" alt="CEBA" />
            </div>
            <div class="item-clientes">
                <img class="img-responsive" src="/assets/images/clients/cesf.png" alt="CESF" />
            </div>
            <div class="item-clientes">
                <img class="img-responsive" src="/assets/images/clients/eldial.png" alt="ELDIAL" />
            </div>
            <div class="item-clientes">
                <img class="img-responsive" src="/assets/images/clients/enj.png" alt="ENJ" />
            </div>
            <div class="item-clientes">
                <img class="img-responsive" src="/assets/images/clients/externado.png" alt="EXTERNADO" />
            </div>
            <div class="item-clientes">
                <img class="img-responsive" src="/assets/images/clients/faca.png" alt="FACA" />
            </div>
            <div class="item-clientes">
                <img class="img-responsive" src="/assets/images/clients/ieric.png" alt="IERIC" />
            </div>
            <div class="item-clientes">
                <img class="img-responsive" src="/assets/images/clients/lasabana.png" alt="LASABANA" />
            </div>
            <div class="item-clientes">
                <img class="img-responsive" src="/assets/images/clients/mjdh.png" alt="MJDH" />
            </div>
            <div class="item-clientes">
                <img class="img-responsive" src="/assets/images/clients/mpf.png" alt="MPF" />
            </div>
            <div class="item-clientes">
                <img class="img-responsive" src="/assets/images/clients/nacion.png" alt="NACION" />
            </div>
            <div class="item-clientes">
                <img class="img-responsive" src="/assets/images/clients/pjcba.png" alt="PJCBA" />
            </div>
            <div class="item-clientes">
                <img class="img-responsive" src="/assets/images/clients/pjdf.png" alt="PJDF" />
            </div>
            <div class="item-clientes">
                <img class="img-responsive" src="/assets/images/clients/pjdj.png" alt="PJDJ" />
            </div>
            <div class="item-clientes">
                <img class="img-responsive" src="/assets/images/clients/pjdlpdba.png" alt="PJDLPDBA" />
            </div>
            <div class="item-clientes">
                <img class="img-responsive" src="/assets/images/clients/pjlp.png" alt="PJLP" />
            </div>
            <div class="item-clientes">
                <img class="img-responsive" src="/assets/images/clients/pjsde.png" alt="PJSDE" />
            </div>
            <div class="item-clientes">
                <img class="img-responsive" src="/assets/images/clients/ucbsp.png" alt="UCBSP" />
            </div>
            <div class="item-clientes">
                <img class="img-responsive" src="/assets/images/clients/uda.png" alt="UDA" />
            </div>
            <div class="item-clientes">
                <img class="img-responsive" src="/assets/images/clients/udechile.png" alt="UDECHILE" />
            </div>
            <div class="item-clientes">
                <img class="img-responsive" src="/assets/images/clients/udr.png" alt="UDR" />
            </div>
            <div class="item-clientes">
                <img class="img-responsive" src="/assets/images/clients/ulibertadores.png" alt="ULIBERTADORES" />
            </div>
            <div class="item-clientes">
                <img class="img-responsive" src="/assets/images/clients/um.png" alt="UM" />
            </div>
            <div class="item-clientes">
                <img class="img-responsive" src="/assets/images/clients/unca.png" alt="UNCA" />
            </div>
            <div class="item-clientes">
                <img class="img-responsive" src="/assets/images/clients/undc.png" alt="UNDC" />
            </div>
            <div class="item-clientes">
                <img class="img-responsive" src="/assets/images/clients/undmdq.png" alt="UNDMDQ" />
            </div>
            <div class="item-clientes">
                <img class="img-responsive" src="/assets/images/clients/unilibre.png" alt="UNLIBRE" />
            </div>
            <div class="item-clientes">
                <img class="img-responsive" src="/assets/images/clients/unsl.png" alt="UNSL" />
            </div>
            <div class="item-clientes">
                <img class="img-responsive" src="/assets/images/clients/usac.png" alt="USAC" />
            </div>
            <div class="item-clientes">
                <img class="img-responsive" src="/assets/images/clients/usal.png" alt="USAL" />
            </div>

        </div>
    </div>

</div>
